
import {Component, Emit, Prop, Watch, Vue} from "vue-property-decorator";
import Opt from "@/ts/ToolButton";
import {SizeEnum} from "@/ts/Enum";

@Component
export default class ToolButton extends Vue {
  /**
   * 父组件传入的操作按钮对象，包含按钮名称，默认图标，活跃状态等
   */
  @Prop() opt: Opt
  /**
   * 父组件传入的使用组件的样式。
   */
  @Prop() size: SizeEnum

  /**
   * 组件内部绑定的操作按钮对象。 等于父组件传入的操作按钮对象。
   * <p>
   *   单独声明一个组件内部的操作按钮对象，是为了方便在组件内部实现组件本身的状态切换、内容更改等操作。
   *   因为父组件传入的对象，严格上是不允许在子组件内部对其进行更改的。
   * </p>
   */
  toolButton: Opt

  created(): void {
    // 对组件内部绑定的操作按钮对象赋值
    this.toolButton = this.opt
  }

  @Watch('opt', {deep: true, immediate: true})
  optWatch() {
    if (this.opt) {
      this.toolButton = this.opt
    }
  }

  get imageSrc() {
    if (this.opt.img) {
      return require(`@/assets/images/${this.toolButton.img}`);
    }
    return null;
  }

  /**
   * 工具栏点击事件
   * <p>
   *   1、更改按钮本身的状态
   *   2、将按钮点击事件传递给父组件，同时被点击按钮的索引和活跃状态
   * </p>
   */
  activeClick() {
    // 更改按钮本身的状态
    this.toolButton.setActive(!this.toolButton.getActive())
    // 触发父组件引用的点击事件
    this.$emit('activeClick', this.toolButton.key, this.toolButton.getActive())
  }
}
